declare const Object: any;

/**
 * Interface for API model
 */
export interface APIModelInterface {
  id: string;

  getModelName();
  factory(data: APIModelInterface);
}

/**
 * Class BaseAPIModel
 */
export class BaseAPIModel implements APIModelInterface {
  id: string;

  constructor(data?: APIModelInterface) {
    if (data) {
      Object.assign(this, data);
    }
  }

  getModelName() {
    return this.constructor.name;
  }

  factory(data: APIModelInterface) {
    if (data) {
      return new BaseAPIModel(data);
    }
    return null;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/api.model.ts